module.exports = __webpack_public_path__ + "static/img/newappqrcode.e7373f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/newappqrcode.png
// module id = cNez
// module chunks = 51